import { useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { Layers, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";

export default function Login() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const loc = useLocation();
  if (user) return <Navigate to={loc.state?.from || "/"} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      navigate(loc.state?.from || "/", { replace: true });
    } catch (err) {
      setError(errMsg(err, "Login failed"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid-bg grid place-items-center px-4">
      <form onSubmit={submit} className="w-full max-w-sm rounded-2xl border border-slate-800 bg-slate-900/90 backdrop-blur-xl p-8 space-y-6 fade-up" data-testid="login-form">
        <div className="flex items-center gap-2">
          <span className="h-9 w-9 rounded-md bg-emerald-500 grid place-items-center"><Layers className="h-4 w-4 text-emerald-950" /></span>
          <span className="font-display font-bold tracking-tight text-xl">Feasi<span className="text-emerald-400">Craft</span></span>
        </div>
        <div>
          <h1 className="font-display text-2xl font-bold tracking-tight">Staff sign in</h1>
          <p className="text-sm text-slate-400 mt-1">Accounts are created by your administrator.</p>
        </div>
        <div className="space-y-2"><Label className="text-xs uppercase tracking-wider text-slate-400">Email</Label>
          <Input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="bg-slate-950/60 border-slate-700" /></div>
        <div className="space-y-2"><Label className="text-xs uppercase tracking-wider text-slate-400">Password</Label>
          <Input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="bg-slate-950/60 border-slate-700" /></div>
        {error && <p data-testid="login-error" className="text-sm text-rose-400">{error}</p>}
        <Button data-testid="login-submit" disabled={loading} className="w-full h-11 rounded-full bg-emerald-500 text-emerald-950 hover:bg-emerald-400 font-semibold">
          {loading && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}Sign in
        </Button>
      </form>
    </div>
  );
}
